
import BSelect from 'Src/js/components/blain-form/BSelect.vue';
import StepWrapper from './StepWrapper.vue';
import WithImmutableObjectValue from 'JS/mixins/WithImmutableObjectValue';
import { Component, Inject, Mixins, Prop, Watch } from 'vue-property-decorator';
import { IVehicleLookupService } from 'Src/js/services/automotive/VehicleLookupService';
import { VehicleStep as IVehicleStep } from '../types/steps';

@Component({
	name: 'VehicleStep',
	components: {
		BSelect,
		StepWrapper,
	}
})
class VehicleStep extends Mixins(WithImmutableObjectValue<IVehicleStep['data']>(() => ({
		availableYears: null,
		availableMakes: null,
		availableModels: null,
		year: null,
		make: null,
		model: null,
	}))) {

	$refs!: {
		wrapper: StepWrapper;
	}

	@Inject('VehicleLookupService')
	_vehicleLookupService: IVehicleLookupService;

	get canContinue() {
		return !!this.year && !!this.make && !!this.model;
	}

	async mounted() {
		const { year } = this.value;

		if (!year) {
			this.availableYears = await this._vehicleLookupService.getTireYears();
		}

	}

	@Watch('year')
	async onYearChange(year: IVehicleStep['data']['year']) {
		this.availableMakes = [];
		this.availableModels = [];
		this.make = '';
		this.model = '';

		if (!year) {
			return;
		}

		this.availableMakes = await this._vehicleLookupService.getTireMakes(year);

		this.$refs.wrapper.formHandle.resetValidation();
	}

	@Watch('make')
	async onMakeChange(make: IVehicleStep['data']['make']) {
		this.availableModels = [];
		this.model = '';

		if (!make) {
			return;
		}

		this.availableModels = await this._vehicleLookupService.getTireModels(this.value.year, make);

		this.$refs.wrapper.formHandle.resetValidation();
	}
}

export default VehicleStep;
